/** Pure helpers for extracting the one-time session token from the URL. */

/** Read the `s` query parameter from a URL search string. */
export function readSessionToken(search: string): string | null {
  const params = new URLSearchParams(search);
  const s = params.get("s");
  return s && s.trim().length > 0 ? s.trim() : null;
}
